<script lang="ts" setup>
import { computed } from 'vue'

const { stencil, color } = defineProps<{
  stencil: 'blobs' | 'triangle' | 'zigzag' | 'halfcircle' | 'none'
  color?: string
}>()

const svgData = computed(() => {
  const svgs = {
    blobs: {
      viewBox: '0 0 286 552',
      path: 'M0 0h158.989C189.371 0 214 24.63 214 55.01c0 30.382-24.63 55.011-55.011 55.011H57.516c30.643 0 55.484 24.841 55.484 55.484s-24.841 55.484-55.484 55.484h121.473c30.382 0 55.011 24.63 55.011 55.011 0 30.381-24.629 55.011-55.011 55.011h51.527c30.643 0 55.484 24.841 55.484 55.484s-24.841 55.484-55.484 55.484h-55.527c30.381 0 55.011 24.629 55.011 55.01C230 527.371 205.371 552 174.989 552H0V0Z'
    },
    halfcircle: {
      viewBox: '0 0 227 552',
      path: 'M0 0h227S32 62 32 276s195 276 195 276H0V0Z'
    },
    zigzag: {
      viewBox: '0 0 196 552',
      path: 'M195.5 0 64.799 139.969 195.5 277.237 65.965 415.957 195.5 552H0V0h195.5Z'
    },
    triangle: {
      viewBox: '0 0 217 552',
      path: 'M0 0h217L0 552V0Z'
    },
    none: null
  }
  return svgs[stencil]
})

const bgColor = computed(() => ({ color: color || 'var(--theme-60)' }))
</script>

<template>
  <svg
    v-if="svgData"
    :style="bgColor"
    :viewBox="svgData.viewBox"
    class="h-full"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path :d="svgData.path" fill="currentColor" />
  </svg>
</template>
